/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'ToolSetEntry'>;
const hooks = useModelQueries(schema, 'ToolSetEntry');

export const useAggregateToolSetEntry: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountToolSetEntry: Hooks['useCount'] = hooks.useCount;
export const useCreateToolSetEntry: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyToolSetEntry: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnToolSetEntry: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteToolSetEntry: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyToolSetEntry: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsToolSetEntry: Hooks['useExists'] = hooks.useExists;
export const useFindFirstToolSetEntry: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyToolSetEntry: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueToolSetEntry: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByToolSetEntry: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyToolSetEntry: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateToolSetEntry: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountToolSetEntry: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstToolSetEntry: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyToolSetEntry: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueToolSetEntry: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByToolSetEntry: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyToolSetEntry: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateToolSetEntry: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyToolSetEntry: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnToolSetEntry: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertToolSetEntry: Hooks['useUpsert'] = hooks.useUpsert;
